function toggleSearch() {
  const buttonOpenSearch = document.querySelector(".header .button-search");
  const buttonCloseSearch = document.querySelector(
    ".wrapper-pesquisa .close-search"
  );
  const searchContainer = document.querySelector(".wrapper-pesquisa");

  if (!buttonCloseSearch || !buttonOpenSearch || !searchContainer) return;

  buttonOpenSearch.addEventListener("click", () => {
    searchContainer.classList.add("active");
  });

  buttonCloseSearch.addEventListener("click", () => {
    searchContainer.classList.remove("active");
  });
}

export { toggleSearch };
